import { optionSubcategory_premium } from './premiumDashboardSubCategory.locstring.json';
import { OptionSubCategory } from 'owa-options-core';
import { PremiumStorageOption } from 'owa-premium-storage-option';
import { SubscriptionOption } from 'owa-subscription-option';
import { AdvancedSecurityOption } from 'owa-advanced-security-option';
import { loadStorageInformation } from '../util/loadStorageInformation';

let premiumDashboardSubCategory: OptionSubCategory = {
    key: 'Premium',
    titleStringKey: optionSubcategory_premium,
    options: [SubscriptionOption, AdvancedSecurityOption, PremiumStorageOption], // Make sure mailbox cleanup is the last thing shown.
    onSelected: () => {
        return loadStorageInformation();
    },
    refreshOnSelected: true,
};

export default premiumDashboardSubCategory;
